import { z } from "zod";

export const familyMemberFormSchema = z.object({
  email: z.string().email("Invalid email address"),
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  family_role: z.enum(["spouse", "child", "dependent"]),
});

export type FamilyMemberFormValues = z.infer<typeof familyMemberFormSchema>;

export interface FamilyMember {
  id: string;
  full_name: string;
  email: string;
  family_role: string;
  relationship_verified: boolean;
}

export interface FamilyGroup {
  id: string;
  primary_member_id: string;
  name: string | null;
  created_at: string | null;
  updated_at: string | null;
  settings: any;
  members: FamilyMember[];
}